import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb7bb720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex h-full border-l" }
const _hoisted_2 = { class: "flex flex-col justify-center w-4/5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, " Status ", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center space-x-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col justify-center w-4/5"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col justify-center w-4/5"
}
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end items-center w-1/5"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute rounded bg-white p-2 w-48 border rounded top-0 mt-20"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex items-center space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center py-2 px-4 w-48 h-full font-semibold", {
        'hover:bg-gray-200 cursor-pointer': !_ctx.readOnly
      }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowOptions && _ctx.toggleShowOptions(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.selectedOption && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "rounded-full h-2 w-2",
                style: _normalizeStyle(_ctx.selectedOption.circleStyle)
              }, null, 4),
              _createElementVNode("div", null, _toDisplayString(_ctx.selectedOption.name), 1)
            ]))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('platform.common.loading')) + "...", 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('custom.uhb.consult.no-triage-set')), 1)
              ]))
      ]),
      (!_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!_ctx.showOptions)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 0,
                  name: "chevron-down"
                }))
              : (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 1,
                  name: "chevron-up"
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedOptions, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded triage h-10 bg-white cursor-pointer px-4 flex items-center font-semibold hover:text-white",
              style: _normalizeStyle(item.style),
              onClick: ($event: any) => (_ctx.selectTriage(item.id))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "rounded-full h-2 w-2 triage-circle",
                  style: _normalizeStyle(item.circleStyle)
                }, null, 4),
                _createElementVNode("div", null, _toDisplayString(item.name), 1)
              ])
            ], 12, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_away, _ctx.clickAway]
  ])
}